/**
 * เดินช้า / เดินเร็ว (data/walkModes.ts): the player's walking pace in a zone that walks. `walkMode` switches it (to
 * `mode`, or to the other one), saved in `progress.walkMode`; the player's speed follows at once
 * (`World.refreshPlayerStats`, which sets a walking zone's pace through `walkPace`).
 */
import { DEFAULT_WALK_MODE, WALK_MODES, type WalkMode } from '../data/walkModes';
import type { SystemHost, WorldSystem } from './types';

/** Commands (part of `PlayerCommand`). */
export type WalkModeCommand = { t: 'walkMode'; mode?: WalkMode };

export class WalkModeSystem implements WorldSystem {
  readonly name = 'walkMode';

  constructor(private readonly h: SystemHost) {}

  readonly commands = {
    walkMode: (cmd: WalkModeCommand) => {
      const w = this.h.world;
      const now = w.progress.walkMode ?? DEFAULT_WALK_MODE;
      const next = cmd.mode ?? (now === 'fast' ? 'slow' : 'fast');
      if (next === now && w.progress.walkMode) return;
      w.progress.walkMode = next;
      w.refreshPlayerStats();
      this.h.notice(WALK_MODES[next].label);
    },
  };
}
